import { render } from "./CheckoutReferralNotification.vue?vue&type=template&id=4ed5e407"
import script from "./CheckoutReferralNotification.vue?vue&type=script&lang=js"
export * from "./CheckoutReferralNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__